// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"2428a29e","152":"9d2bd1d2","281":"bca9286d","453":"5caa5f0a","771":"43758f15","797":"acf66c34","825":"d6004851","887":"4cd0bc34","992":"42d36ad9"}[chunkId] + ".chunk.js";
};